import React from 'react';
import styled, { css } from 'styled-components';
import {
  brandColours,
  fontSize,
  fontWeights,
  standardColours,
  standardTransition,
} from '../../styles';
import { Link } from './Link';
import arrowIcon from '../../images/arrow-icon.svg';

const commonArrowButtonStyles = () => {
  return css`
    position: relative;
    display: inline-block;
    font-weight: ${fontWeights.semibold};
    ${fontSize(16)};
    line-height: 1.5;
    text-align: center;
    background-color: ${standardColours.grey};
    border-radius: 30px;
    transition: ${standardTransition('background-color')};
    padding: 14px 30px;

    ${({ alt }) => {
      if (alt) {
        return css`
          padding-left: 50px;
          &:after {
            content: '';
            position: absolute;
            top: 50%;
            left: 25px;
            display: block;
            height: 16px;
            width: 16px;
            background: url(${arrowIcon}) no-repeat 50% / 16px;
            transform: translateY(50%);
            rotate: 180deg;
            filter: invert(1);
          }
        `;
      } else {
        return css`
          padding-right: 50px;
          &:before {
            content: '';
            position: absolute;
            top: 50%;
            right: 25px;
            display: block;
            height: 16px;
            width: 16px;
            background: url(${arrowIcon}) no-repeat 50% / 16px;
            transform: translateY(-50%);
            filter: invert(1);
          }
        `;
      }
    }}

    &:hover {
      background-color: ${brandColours.tertiary};
    }
  `;
};

const StyledArrowButton = styled.button`
  ${commonArrowButtonStyles()};
  border: none;
`;

const StyledArrowButtonLink = styled(Link)`
  ${commonArrowButtonStyles()};
`;

const StyledArrowButtonLinkExternal = styled.a`
  ${commonArrowButtonStyles()};
`;

export const ArrowButton = ({ children, alt, ...props }) => {
  const ArrowButtonComponent = props.to
    ? StyledArrowButtonLink
    : props.href
    ? StyledArrowButtonLinkExternal
    : StyledArrowButton;

  return (
    <ArrowButtonComponent alt={alt} {...props}>
      {children}
    </ArrowButtonComponent>
  );
};
